import constantes from '../helpers/constanteHelper'

import Button from 'react-bootstrap/Button'

import { FaBoxOpen, FaBriefcase, FaInfoCircle } from 'react-icons/fa'


function OpcaoMenu({ texto, opcao, funcao, largura, altura, opcaoSelecionada }) {
    
    // Ver se a opção selecionada atualmente é a que foi passada
    const selecionado = opcaoSelecionada === opcao

    function _retornarIcone(opcao) {
        const icones = {
            sobre: <FaInfoCircle size={25} style={{ color: selecionado ? constantes.CORES.MARROM_OVO_CAIPIRA : constantes.CORES.BRANCO_PADRAO }} />,
            empresas: <FaBriefcase size={25} style={{ color: selecionado ? constantes.CORES.MARROM_OVO_CAIPIRA : constantes.CORES.BRANCO_PADRAO }} />,
            produtos: <FaBoxOpen size={25} style={{ color: selecionado ? constantes.CORES.MARROM_OVO_CAIPIRA : constantes.CORES.BRANCO_PADRAO }} />,
        }

        return icones[opcao]
    }

    const style = {
        width: largura ? `${largura}px` : '180px',
        height: altura ? `${altura}px` : '50px',
        background: selecionado ? constantes.CORES.BRANCO_PADRAO : 'transparent',
        fontSize: '18px',
        border: 'none'
    }

    return (
        <Button type='submit' style={style} onClick={funcao ? funcao : () => { }} className='d-flex align-items-center justify-content-center mt-3'>
            {_retornarIcone(opcao)}
            <div style={{ width:'15px' }}></div>
            <span style={{ fontWeight: 600, color: selecionado ? constantes.CORES.MARROM_OVO_CAIPIRA : constantes.CORES.BRANCO_PADRAO }}>
                {texto}
            </span>

        </Button>
    );
}
export default OpcaoMenu;
